var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddToList1({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .atl-cls-1 {\n        stroke-miterlimit: 10;\n        stroke-width: 20px;\n      }\n\n      .atl-cls-1, .atl-cls-2 {\n        fill: none;\n        stroke: #000;\n      }\n\n      .atl-cls-2 {\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 23px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(0.06877894447246549 0.06168968034463968)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "atl-cls-1",
    d: "m156.05,308.15H50c-22,0-40-18-40-40V50c0-22,18-40,40-40h209.011c22,0,40,18,40,40v164.939"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "atl-cls-1",
    cx: 247.497,
    cy: 287.597,
    r: 91.447
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 64.023,
    cy: 89.413,
    r: 12.699
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 64.023,
    cy: 157.375,
    r: 12.699
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 64.023,
    cy: 225.337,
    r: 12.699
  }), /*#__PURE__*/React.createElement("line", {
    className: "atl-cls-2",
    x1: 110.734,
    y1: 89.413,
    x2: 243.497,
    y2: 89.413
  }), /*#__PURE__*/React.createElement("line", {
    className: "atl-cls-2",
    x1: 247.497,
    y1: 320.639,
    x2: 247.497,
    y2: 254.257
  }), /*#__PURE__*/React.createElement("line", {
    className: "atl-cls-2",
    x1: 280.688,
    y1: 287.597,
    x2: 214.306,
    y2: 287.597
  }), /*#__PURE__*/React.createElement("line", {
    className: "atl-cls-2",
    x1: 110.734,
    y1: 157.375,
    x2: 243.497,
    y2: 157.375
  }), /*#__PURE__*/React.createElement("line", {
    className: "atl-cls-2",
    x1: 110.734,
    y1: 225.337,
    x2: 175.158,
    y2: 225.337
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddToList1);
export default __webpack_public_path__ + "static/media/add-to-list-1.424ce3c0df47e1d328e337eee7e74d9f.svg";
export { ForwardRef as ReactComponent };